const SocialLoginProvider = {
	GOOGLE: 'google',
	TWITTER: 'twitter',
	FACEBOOK: 'facebook',
	APPLE: 'apple',
} as const;

export default SocialLoginProvider;
